"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _useAccessory2 = require("../../../../hooks/upsell/useAccessory");
var _services = require("../../../../services");
var _upsellActions = require("../../../../store/upsell/upsellActions");
var _upsellUtils = require("../../../../utils/upsellUtils");
var _SliderWithIcon = _interopRequireDefault(require("./SliderWithIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var RangeSliders = function RangeSliders(_ref) {
  var onChangePaymentValues = _ref.onChangePaymentValues;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useAccessory = (0, _useAccessory2.useAccessory)(),
    currentVariant = _useAccessory.currentVariant,
    slidersValues = _useAccessory.slidersValues;
  var _currentVariant$price = currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.priceOffering,
    totalPriceValue = _currentVariant$price.totalPrice.value,
    maxUpfrontValue = _currentVariant$price.maxUpfront.value,
    minUpfrontValue = _currentVariant$price.minUpfront.value,
    upfrontIncrementStep = _currentVariant$price.upfrontIncrementStep,
    maxTermValue = _currentVariant$price.maxTerm.value,
    minTermValue = _currentVariant$price.minTerm.value,
    termIncrementStep = _currentVariant$price.termIncrementStep;
  var _useState = (0, _react.useState)(minUpfrontValue),
    _useState2 = _slicedToArray(_useState, 2),
    upFrontValue = _useState2[0],
    setUpFrontValue = _useState2[1];
  var _useState3 = (0, _react.useState)(maxTermValue),
    _useState4 = _slicedToArray(_useState3, 2),
    recurringValue = _useState4[0],
    setRecurringValue = _useState4[1];
  var evaluatedPriceStep = (0, _react.useMemo)(function () {
    return (0, _upsellUtils.evaluateStepValue)({
      min: minUpfrontValue,
      max: maxUpfrontValue,
      stepValue: upfrontIncrementStep.value
    });
  }, [minUpfrontValue, maxUpfrontValue, upfrontIncrementStep]);
  var evaluatedTermStep = (0, _react.useMemo)(function () {
    return (0, _upsellUtils.evaluateStepValue)({
      min: minTermValue,
      max: maxTermValue,
      stepValue: termIncrementStep.value
    });
  }, [minTermValue, maxTermValue, termIncrementStep]);
  (0, _react.useEffect)(function () {
    var currentVariantData = slidersValues === null || slidersValues === void 0 ? void 0 : slidersValues[currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.id];
    setUpFrontValue((currentVariantData === null || currentVariantData === void 0 ? void 0 : currentVariantData.upFrontValue) || minUpfrontValue);
    setRecurringValue((currentVariantData === null || currentVariantData === void 0 ? void 0 : currentVariantData.recurringValue) || maxTermValue);
  }, [currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.priceOffering]);
  (0, _react.useEffect)(function () {
    onChangePaymentValues({
      totalPriceValue: totalPriceValue,
      upFrontValue: upFrontValue,
      recurringValue: recurringValue
    });
  }, [upFrontValue, recurringValue]);
  var handleOnValueDecrease = function handleOnValueDecrease(value, incrementStep, minValue, callbackFn, valueKey) {
    var updatedValue = value - incrementStep < minValue ? value : value - incrementStep;
    callbackFn(updatedValue);
    dispatch((0, _upsellActions.setSlidersValues)(_defineProperty({
      id: currentVariant.id
    }, valueKey, updatedValue)));
  };
  var handleOnValueIncrease = function handleOnValueIncrease(value, incrementStep, maxValue, callbackFn, valueKey) {
    var updatedValue = value + incrementStep <= maxValue ? value + incrementStep : maxValue;
    callbackFn(updatedValue);
    dispatch((0, _upsellActions.setSlidersValues)(_defineProperty({
      id: currentVariant.id
    }, valueKey, updatedValue)));
  };
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_SliderWithIcon.default, {
    title: _services.locale.localeString('AccessoryModal.FirstSliderLabel'),
    minLabel: "".concat(_services.locale.localeString('AccessoryModal.Min'), " ").concat(minTermValue),
    maxLabel: "".concat(_services.locale.localeString('AccessoryModal.Max'), " ").concat(maxTermValue),
    minValue: minTermValue,
    maxValue: maxTermValue,
    increment: evaluatedTermStep,
    value: recurringValue,
    onChangeHandle: function onChangeHandle(selectedIndex) {
      setRecurringValue(selectedIndex);
      dispatch((0, _upsellActions.setSlidersValues)({
        id: currentVariant.id,
        recurringValue: selectedIndex
      }));
    },
    sliderLabel: "".concat(recurringValue, " ").concat(_services.locale.localeString('AccessoryModal.Months')),
    onDecrease: function onDecrease() {
      handleOnValueDecrease(recurringValue, evaluatedTermStep, minTermValue, setRecurringValue, 'recurringValue');
    },
    onIncrease: function onIncrease() {
      handleOnValueIncrease(recurringValue, evaluatedTermStep, maxTermValue, setRecurringValue, 'recurringValue');
    }
  }), /*#__PURE__*/_react.default.createElement(_SliderWithIcon.default, {
    title: _services.locale.localeString('AccessoryModal.SecondSliderLabel'),
    minLabel: "".concat(_services.locale.localeString('AccessoryModal.Min'), " ").concat(_services.locale.formatPrice(minUpfrontValue, {
      fraction: false
    })),
    maxLabel: "".concat(_services.locale.localeString('AccessoryModal.Max'), " ").concat(_services.locale.formatPrice(maxUpfrontValue, {
      fraction: false
    })),
    value: upFrontValue,
    maxValue: maxUpfrontValue,
    minValue: minUpfrontValue,
    increment: evaluatedPriceStep,
    onChangeHandle: function onChangeHandle(selectedIndex) {
      setUpFrontValue(selectedIndex);
      dispatch((0, _upsellActions.setSlidersValues)({
        id: currentVariant.id,
        upFrontValue: selectedIndex
      }));
    },
    sliderLabel: "".concat(_services.locale.formatPrice(upFrontValue, {
      fraction: false
    })),
    onDecrease: function onDecrease() {
      handleOnValueDecrease(upFrontValue, evaluatedPriceStep, minUpfrontValue, setUpFrontValue, 'upFrontValue');
    },
    onIncrease: function onIncrease() {
      handleOnValueIncrease(upFrontValue, evaluatedPriceStep, maxUpfrontValue, setUpFrontValue, 'upFrontValue');
    }
  }));
};
var _default = RangeSliders;
exports.default = _default;